import { render } from "./SubirFicheroCard.vue?vue&type=template&id=5908e752"
import script from "./SubirFicheroCard.vue?vue&type=script&lang=js"
export * from "./SubirFicheroCard.vue?vue&type=script&lang=js"

import "./SubirFicheroCard.vue?vue&type=style&index=0&id=5908e752&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__